import React, { useState, useEffect, useRef } from 'react'
import {
	Row,
	Col,
	Nav,
	Tabs,
	Tab,
	Card,
	Modal,
	Image,
	Button,
	FormControl
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	faChevronRight,
	faChevronLeft,
	faFile,
	faFileDownload
} from '@fortawesome/free-solid-svg-icons'
import styles from './JobDetails.module.scss'
import 'react-day-picker/lib/style.css'
import { useParams } from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import moment from 'moment'
import { CSVLink } from 'react-csv'
import axios from 'axios'
import parse from 'html-react-parser'
import EButton from '../../components/bootstrap-extended/EButton'

interface ApplicantProps {
	id: number
	name: string
	age: number
	avatar: string
	gender: string
	nationality: string
	location: string
}

const JobDetails = () => {
	const csvLink = useRef<any | null>(null)
	const param = useParams()
	const jobId = param.id !== undefined ? parseInt(param.id) : ''

	const [jobDetails, setJobDetails] = useState<{ [key: string]: any }>({})
	const [jobApplicants, setJobApplicants] = useState<Array<ApplicantProps> | null>([])
	const [currentPage, setCurrentPage] = useState(1)

	const [dataExport, setDataExport] = useState<any[]>([])
	const [dataAggregate, setDataAggregate] = useState(0)

	const [filterPage, setFilterPage] = useState('')

	const [key, setKey] = useState<string>('details')
	const [applicantDetails, setApplicantDetails] = useState<any>(null)
	const [pageNo, setPageNo] = useState('')
	const [toPage, setToPage] = useState<number>(0)
	const [showProfile, setShowProfile] = useState(false)
	const [isLoading, setIsLoading] = useState(true)

	// pagination
	const [pageCount, setPageCount] = useState(0)
	const [itemOffset, setItemOffset] = useState(0)
	const itemsPerPage = 10

	const exportHeader = [
		{ label: 'Applicant Name', key: 'name' },
		{ label: 'Age', key: 'age' },
		{ label: 'Gender', key: 'gender' },
		{ label: 'Nationality', key: 'nationality' },
		{ label: 'Location', key: 'location' },
		{ label: 'Total job applied', key: 'numberOfApplications' },
	]

	useEffect(() => {
		const getJobDetails = async () => {
			try {
				const res = await axios.get(process.env.REACT_APP_ROUTE_GET_JOB as string + `/${jobId}`)
				setJobDetails(res.data)
				setIsLoading(false)
			} catch (err) {
				console.log(err)
			}
		}
		getJobDetails()
	}, [])

	useEffect(() => {
		const getApplicants = async () => {
			try {
				const res = await axios.get(process.env.REACT_APP_ROUTE_GET_APPLICANT as string + `?page=${currentPage}&jobId=${jobId}`)
				setJobApplicants(res.data.applicants)
				setPageCount(Math.ceil(res.data.applicantAggregate / itemsPerPage))
				setDataAggregate(res.data.applicantAggregate)
			} catch (err) {
				console.log(err)
			}
		}
		getApplicants()
	}, [currentPage])

	useEffect(() => {
		if (dataExport && csvLink && csvLink.current && csvLink.current.link) {
			setTimeout(() => {
				csvLink.current.link.click()
				setDataExport([])
			})
		}
	}, [dataExport])

	const getAllApplicants = async () => {
		try {
			const res = await axios.get(process.env.REACT_APP_ROUTE_GET_APPLICANT as string + `?pageSize=${dataAggregate}&jobId=${jobId}`)
			setDataExport(res.data.applicants)
		} catch (err) {
			console.log(err)
		}
	}

	const viewApplicantDetails = async (id: number) => {
		try {
			const res = await axios.get(process.env.REACT_APP_ROUTE_GET_APPLICANT as string + `/${id}`)
			setApplicantDetails(res.data.applicant)
			setShowProfile(true)
		} catch (err) {
			console.log(err)
		}
	}

	// pagination
	useEffect(() => {
		const toNum = () => {
			if (pageNo === '') {
				setItemOffset(0)
				setToPage(0)
			} else {
				const temp = parseInt(pageNo)
				setItemOffset(temp - 1)
				setToPage(temp - 1)
			}
		}
		toNum()
	}, [pageNo])

	const getSalTyp = (val: string) => {
		switch (val) {
		case 'PER DAY':
			return 'day'
		case 'PER HOUR':
			return 'hour'
		case 'PER MONTH':
			return 'month'
		case 'PER WEEK':
			return 'week'
		default:
			return 'month'
		}
	}

	const handlePageClick = (event: { selected: number }) => {
		setCurrentPage(event.selected + 1)
	}

	const numbersOnly = (val: string) => {
		const numsCheck = new RegExp('^[0-9]{1,6}$')//6 digits only
		if (numsCheck.test(val) || val === '') {
			setFilterPage(val)
		}
		if (parseInt(val) > pageCount) {
			setFilterPage(pageCount.toString())
		}
	}

	const submitPageNumber = () => {
		setCurrentPage(parseInt(filterPage))
		setPageNo(filterPage)
	}

	const getStatus = (status: string) => {
		switch (status) {
		case 'SUCCESSFUL':
			return <span className={`badge ${styles.customBadge}`} style={{ backgroundColor: '#EBFFF1', border: '1px solid #2BCB5C', color: '#2BCB5C' }}>{status}</span>

		case 'UNSUCCESSFUL':
			return <span className={`badge ${styles.customBadge}`} style={{ backgroundColor: '#FFF2F2', border: '1px solid #FE6565', color: '#FE6565' }}>{status}</span>

		case 'PENDING':
			return <span className={`badge ${styles.customBadge}`} style={{ backgroundColor: '#FFF3ED', border: '1px solid #FE9465', color: '#FE9465' }}>{status}</span>

		case 'VIEWED':
			return <span className={`badge ${styles.customBadge}`} style={{ backgroundColor: '#F3EFFF', border: '1px solid #8E6CFA', color: '#8E6CFA' }}>{status}</span>

		case 'SHORTLISTED':
			return <span className={`badge ${styles.customBadge}`} style={{ backgroundColor: '#E5F5FF', border: '1px solid #1CA8FF', color: '#1CA8FF' }}>{status}</span>

		case 'CONTACTUNLOCKED':
			return <span className={`badge ${styles.customBadge}`} style={{ backgroundColor: '#EBFFF1', border: '1px solid #2BCB5C', color: '#2BCB5C' }}>{status}</span>
		}
	}

	return (
		<div>
			<Row className={styles.searchCompRow}>
				{/* hide breadcrumb on xs */}
				<Col className="d-none d-sm-block">
					<Nav className={styles.breadCrumb}>
						<Nav.Item>
							<Nav.Link href="/jobs" style={{ paddingLeft: '0px' }}>Jobs</Nav.Link>
						</Nav.Item>
						<div className={styles.dateArrow}>
							<FontAwesomeIcon icon={faChevronRight} size="xs" color="#5B7493" />
						</div>
						<Nav.Item>
							<Nav.Link style={{ textDecoration: 'underline', color: '#233953' }}>Job Details</Nav.Link>
						</Nav.Item>
					</Nav>
				</Col>
				{key === 'applicants' && (
					<Col lg={2} md={2}>
						<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
							<div onClick={getAllApplicants}>
								<EButton
									buttonText='Export'
									icon={<FontAwesomeIcon icon={faFileDownload} />} isSubmitting={false} className={styles.cusBtn}
								/>
							</div>
							{dataExport.length > 0 ?
								<CSVLink
									data={dataExport}
									headers={exportHeader}
									filename={`${jobDetails.title} - Applicants.csv`}
									ref={csvLink}
								/>
								: undefined
							}
						</div>
					</Col>
				)}
			</Row>

			<Tabs activeKey={key} variant='pills' className={styles.jobDetailsTab} onSelect={(key: string) => setKey(key)}>
				{/* tab 1 */}
				<Tab title='Job Details' eventKey='details'>
					<Card className={styles.tabsCard}>
						<h6 className='fw-bold'>{jobDetails.title}</h6>
						{jobDetails.salaries && jobDetails.salaries.map((salary: any, i: number) => {
							return (
								<h6 key={i}>
									{salary.min > 0 ? `$${salary.min}` : ''}
									{salary.min > 0 && salary.max > 0 ? ' - ' : ''}
									{salary.max > 0 ? `$${salary.max}` : ''}
									{' / '}
									{getSalTyp(salary.salaryType)}
								</h6>
							)
						})}
						<br />
						<p className='mt-4'>{parse(`${jobDetails.description}`)}</p>
						<br />

						<Row>
							<Col md={2}>
								<h6 className='lh-sm'>Vacancies</h6>
							</Col>
							<Col>
								{jobDetails.vacancies !== null ? (
									<p className='lh-sm'>{jobDetails.vacancies}</p>
								) : (
									<p className='lh-sm'>-</p>
								)}
							</Col>
						</Row>

						<Row>
							<Col md={2}>
								<h6 className='lh-sm'>Branch address</h6>
							</Col>
							<Col>
								{jobDetails.locations ? (
									jobDetails.locations && jobDetails.locations.map((location: any, i: number) => {
										return (
											<p key={i} className='lh-sm'>{location}</p>
										)
									})
								) : (
									<p className='lh-sm'>-</p>
								)}
							</Col>
						</Row>

						<Row>
							<Col md={2}>
								<h6 className='lh-sm'>Job posting date</h6>
							</Col>
							<Col>
								<p className='lh-sm'>{moment(jobDetails.createdAt).format('DD MMM YYYY')}</p>
							</Col>
						</Row>

						<Row>
							<Col md={2}>
								<h6 className='lh-sm'>Updates as of</h6>
							</Col>
							<Col>
								<p className='lh-sm'>{moment(jobDetails.updatedAt).format('DD MMM YYYY')}</p>
							</Col>
						</Row>
						<br />
						<Row>
							<Col>
								{jobDetails.application && (
									<>
										<span className={`badge ${styles.customBadge}`} style={{ backgroundColor: '#EDF3FA', border: '1px solid #5B7493', color: '#5B7493' }}>{jobDetails.application.total} Applicant</span>
										<span className={`badge ${styles.customBadge}`} style={{ backgroundColor: '#FFF3ED', border: '1px solid #FE9465', color: '#FE9465' }}>{jobDetails.application.pending} Pending</span>
										<span className={`badge ${styles.customBadge}`} style={{ backgroundColor: '#E5F5FF', border: '1px solid #1CA8FF', color: '#1CA8FF' }}>{jobDetails.application.shortlisted} Shortlisted</span>
										<span className={`badge ${styles.customBadge}`} style={{ backgroundColor: '#EBFFF1', border: '1px solid #2BCB5C', color: '#2BCB5C' }}>{jobDetails.application.successful} Successful</span>
										<span className={`badge ${styles.customBadge}`} style={{ backgroundColor: '#FFF2F2', border: '1px solid #FE6565', color: '#FE6565' }}>{jobDetails.application.unsuccessful} Unsuccessful</span>
									</>
								)}
							</Col>
						</Row>
					</Card>
				</Tab>

				{/* tab 2 */}
				<Tab title='Applicants' eventKey='applicants'>
					<Card className={`${styles.tabsCard} p-0`}>
						{jobApplicants && jobApplicants.map((applicant, index) => {
							return (
								<div
									key={index}
									className='border-top p-2 p-sm-0'
									onClick={() =>
										viewApplicantDetails(applicant.id)
									}
								>
									<Row>
										<Col xs={4} sm={2} className='text-center'>
											<Image
												roundedCircle
												src={applicant.avatar !== null ?
													applicant.avatar :
													'https://dashboard.findjobs.com.sg/static/media/default_boy_avatar.dc83eae1.svg'
												}
												style={{ width: '70px', height: '70px', marginTop: '10px', marginBottom: '10px' }}
											/>
										</Col>
										<Col xs={8} className='d-flex align-items-center'>
											<div>
												<h5>{applicant.name}</h5>
												<small>
													{applicant.age} years old | {applicant.gender} | {applicant.nationality} |
													Live in {applicant.location ? applicant.location : '-'}
												</small>
											</div>
										</Col>
										<Col xs={2} className='d-none d-sm-flex align-items-center'>
											<Button
												className={styles.filterBtn}
												onClick={() =>
													viewApplicantDetails(applicant.id)
												}
											>
												<FontAwesomeIcon icon={faFile} />
												<span className='ps-2'>Profile</span>
											</Button>
										</Col>
									</Row>
								</div>
							)
						})}
						{jobApplicants?.length === 0 &&
							<div className='border-top p-2 p-sm-3'>
								No applicants
							</div>}
					</Card>

					<Row style={{ marginTop: '20px' }}>
						<Col />
						<Col>
							<ReactPaginate
								containerClassName={styles.pagination}
								previousClassName="page-item"
								nextLinkClassName="page-link"
								// activeClassName="active"
								activeLinkClassName={styles.paginationActive}
								pageClassName="page-item"
								pageLinkClassName="page-link"
								previousLinkClassName="page-link"
								nextClassName="page-item"
								breakLinkClassName="page-link"
								breakClassName="page-item"
								previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
								pageCount={pageCount}
								onPageChange={handlePageClick}
								nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
								pageRangeDisplayed={3}
								marginPagesDisplayed={3}
								breakLabel="..."
								forcePage={toPage}
							// renderOnZeroPageCount={null}
							/>
						</Col>
						<Col style={{ display: 'flex', justifyContent: 'flex-end' }}>
							<span style={{ fontSize: '14px', color: '#5B7493', paddingTop: '5px' }}>Go to page</span>
							<FormControl
								style={{ width: '15%', display: 'inline-block', margin: '0 10px', height: '35px' }}
								onChange={e => {
									numbersOnly(e.target.value)
								}}
								value={filterPage}
							/>
							<Button onClick={submitPageNumber} variant='primary' className={styles.cusBtn}>
								Go
							</Button>
						</Col>
					</Row>
				</Tab>
			</Tabs>
			<Modal show={showProfile} size='lg' onHide={() => { setShowProfile(false) }}>
				<Modal.Header closeButton className='border-0' />
				<Modal.Body className='px-5 pt-0'>
					{applicantDetails && (
						<>
							<Row>
								<Col xs={4} sm={2} className='text-center'>
									<Image
										roundedCircle
										src={applicantDetails.avatar !== null ?
											applicantDetails.avatar :
											'https://dashboard.findjobs.com.sg/static/media/default_boy_avatar.dc83eae1.svg'
										}
										style={{ width: '70px', height: '70px', marginTop: '10px', marginBottom: '10px' }} />
								</Col>
								<Col xs={8} className='d-flex align-items-center'>
									<div>
										<h5>{applicantDetails.name}</h5>
										<small>{applicantDetails.age} years old | {applicantDetails.gender} | {applicantDetails.nationality} | Live in {applicantDetails.locationOther ? applicantDetails.locationOther : '-'}</small>
									</div>
								</Col>
							</Row>
							<br />
							<Row>
								<Col xs={6} sm={3}>
									<p>
										<span>NRIC</span> <br />
										<span>Date of Birth</span> <br />
										<span>Race</span> <br />
										<span>Street Address</span> <br />
									</p>
								</Col>
								<Col>
									<p>
										<span>{applicantDetails.nric ? applicantDetails.nric : '-'}</span> <br />
										<span>{applicantDetails.dateOfBirth ? applicantDetails.dateOfBirth : '-'}</span> <br />
										<span>{applicantDetails.race ? applicantDetails.race : '-'}</span> <br />
										<span>{applicantDetails.streetAddress ? applicantDetails.streetAddress : '-'}</span> <br />
									</p>
								</Col>
							</Row>
							<hr />
							<p><strong>Job applied with this company</strong></p>
							<div className='overflow-scroll' style={{ height: '400px' }}>
								{applicantDetails.applications.map((job: any, i: number) => {
									return (
										<Row key={i}>
											<Col xs={3} sm={4}>
												<p>{moment(job.appliedOn).format('DD MMM YYYY, h:mm a')}</p>
											</Col>
											<Col xs={4} sm={4}>
												<p><strong>{job.title}</strong></p>
											</Col>
											<Col className='text-end'>
												{getStatus(job.status)}
											</Col>
										</Row>
									)
								})}
							</div>
						</>
					)}
				</Modal.Body>
			</Modal>
		</div>

	)
}

export default JobDetails